var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#FFC900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.818 7.63672L8.18164 8.72763L8.7271 12.5458H9.818H11.4544L13.6362 13.6367L15.2726 13.0913V8.72763L14.7271 9.27308L12.5453 8.72763L9.818 7.63672Z",
    fill: "#FFC900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5V16.5",
    stroke: "#4B4B4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.5V13",
    stroke: "#4B4B4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.4998C8.96732 8.04173 9.59562 7.78516 10.25 7.78516C10.9044 7.78516 11.5327 8.04173 12 8.4998C12.4673 8.95787 13.0956 9.21444 13.75 9.21444C14.4044 9.21444 15.0327 8.95787 15.5 8.4998",
    stroke: "#4B4B4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.9998C8.96732 12.5417 9.59562 12.2852 10.25 12.2852C10.9044 12.2852 11.5327 12.5417 12 12.9998C12.4673 13.4579 13.0956 13.7144 13.75 13.7144C14.4044 13.7144 15.0327 13.4579 15.5 12.9998",
    stroke: "#4B4B4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.c8245a492788eb3bad83bb1aba3542a3.svg";
export { ForwardRef as ReactComponent };